import { useState } from "react";

const Toggle = ({ isOn, onClick, id }) => {
  const [on, setOn] = useState(isOn === 1 ? true : false);

  const handleClick = () => {
    const newState = !on;
    setOn(newState);
    onClick(newState, id);
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      id={id}
      onClick={handleClick}
      className={`relative inline-flex h-[31px] w-[51px] shrink-0 items-center rounded-full transition-colors duration-300 ease-in-out ${
        on ? "bg-green-500" : "bg-gray-300"
      }`}
    >
      <span
        className={`inline-block h-[27px] w-[27px] transform rounded-full bg-white shadow-[0_1px_3px_rgba(0,0,0,0.3)] transition-transform duration-300 ease-in-out ${
          on ? "translate-x-[22px]" : "translate-x-[2px]"
        }`}
      />
    </button>
  );
};

export default Toggle;
